export const vehicleElements = [
  "_id",
  "admission",
  "battery_capacity",
  "blanket_order",
  "branch",
  "color",
  "decommissioning",
  "drive",
  "empty_weight",
  "engine_power",
  "external_vehicle_manager",
  "external_vehicle_manager_email",
  "external_vehicle_manager_number",
  "first_commissioning",
  "first_deliver",
  "fleet_manager",
  "fleet_manager_email",
  "fleet_manager_number",
  "has_fleet_box",
  "home_base",
  "images",
  "imei1",
  "inventory_number",
  "is_favorite",
  "is_reservable",
  "last_deliver",
  "last_service",
  "license_plate",
  "loading_length",
  "loading_width",
  "loading_height",
  "maintenance_contract",
  "matriculation_number",
  "max_speed",
  "name",
  "notes_fleet_manager",
  "notes_fleet_status",
  "notes_fleet_support",
  "notes_report",
  "number_of_axis",
  "number_of_doors",
  "number_of_seats",
  "odometer_offset",
  "operating_hours_offset",
  "owner",
  "payload",
  "range",
  "rating",
  "service_interval_km",
  "service_interval_time",
  "service_interval_trigger",
  "service_partner_actual",
  "service_partner_fix",
  "template_id",
  "transmission",
  "vehicle_manager",
  "vehicle_manager_email",
  "vehicle_manager_number",
  "vehicle_model_id",
  "vin",
];

export const userElements = [
  "first_name",
  "last_name",
  "timezone",
  "language",
  "avatar",
  "phone_number",
  "department",
  "short_sign",
  "role",
  "_id",
  "email",
];

export const driverElements = [
  "birth_date",
  "categories",
  "driver_identification",
  "tacho_card",
  "first_name",
  "last_name",
  "avatar",
  "email",
  "phone_number",
  "user_id",
  "_id",
];

export const deviceElements = ["imei", "customer", "template", "hardware_type", "sim_type"];

export const iotKeyDeviceElements = [
  "company_id",
  "iot_key_id",
  "firmware_version",
  "hardware_version",
  "firmware_config_file",
];
